import { render, staticRenderFns } from "./InterpreterShortInfo.vue?vue&type=template&id=ca428112&scoped=true&"
import script from "./InterpreterShortInfo.vue?vue&type=script&lang=js&"
export * from "./InterpreterShortInfo.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterShortInfo.vue?vue&type=style&index=0&id=ca428112&prod&lang=css&"
import style1 from "./InterpreterShortInfo.vue?vue&type=style&index=1&id=ca428112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca428112",
  null
  
)

export default component.exports